/**
 * DOM Element References
 *
 * Centralized access to all portal DOM elements
 * @module portal/modules/ui/elements
 */

export const els = {
  authCard: document.getElementById('auth-card'),
  app: document.getElementById('app'),
  login: document.getElementById('connect'),
  logout: document.getElementById('logout'),
  openOptions: document.getElementById('open-options'),
  optionsCard: document.getElementById('options-card'),
  settingsTz: document.getElementById('settings-timezone'),
  settingsZip: document.getElementById('settings-zip'),
  settingsUnitsAutoIndicator: document.getElementById('settings-units-auto-indicator'),
  settingsDistanceUnits: document.getElementById('settings-distance-units'),
  settingsTaxRate: document.getElementById('settings-tax-rate'),
  settingsBidderPremium: document.getElementById('settings-bidder-premium'),
  settingsSellerCosts: document.getElementById('settings-seller-costs'),
  settingsFixedLotCost: document.getElementById('settings-fixed-lot-cost'),
  settingsEnableNotifications: document.getElementById('settings-enable-notifications'),
  settingsNotifyLeadMinutes: document.getElementById('settings-notify-lead-minutes'),
  settingsNotificationsPermissionStatus: document.getElementById(
    'settings-notifications-permission-status'
  ),
  saveSettings: document.getElementById('save-settings'),
  profileCompany: document.getElementById('profile-company'),
  firstRunModal: document.getElementById('first-run-modal'),
  firstRunCompany: document.getElementById('first-run-company'),
  firstRunTimeZone: document.getElementById('first-run-timezone'),
  firstRunZip: document.getElementById('first-run-zip'),
  firstRunSubmit: document.getElementById('first-run-submit'),
  firstRunSkip: document.getElementById('first-run-skip'),
  optionsCreditSection: document.getElementById('options-credit-section'),
  optionsCreditCount: document.getElementById('options-credit-count'),
  optionsCreditMeta: document.getElementById('options-credit-meta'),
  optionsSubscriptionStatus: document.getElementById('options-subscription-status'),
  optionsCreditRenewal: document.getElementById('options-credit-renewal'),
  optionsRenewalDate: document.getElementById('options-renewal-date'),
  optionsCreditLoading: document.getElementById('options-credit-loading'),
  optionsBuyCredits: document.getElementById('options-buy-credits'),
  optionsManageSubscription: document.getElementById('options-manage-subscription'),
  cancelSettings: document.getElementById('cancel-settings'),
  useLocal: document.getElementById('use-local'),
  authError: document.getElementById('auth-error'),
  userPill: document.getElementById('user-pill'),
  userName: document.getElementById('user-name'),
  headerCredits: document.getElementById('header-credits'),
  modeBanner: document.getElementById('mode-banner'),
  viewModeControls: document.getElementById('view-mode-controls'),
  viewModeToggle: document.getElementById('view-mode-toggle'),
  viewModeToggleLabel: document.getElementById('view-mode-toggle-label'),
  superadminUserSelector: document.getElementById('superadmin-user-selector'),
  superadminUserSelect: document.getElementById('superadmin-user-select'),
  superadminUserCredits: document.getElementById('superadmin-user-credits'),
  superadminCreditBalance: document.getElementById('superadmin-credit-balance'),
  superadminCreditStatus: document.getElementById('superadmin-credit-status'),
  superadminCreditRenewal: document.getElementById('superadmin-credit-renewal'),
  superadminAdjustCreditsBtn: document.getElementById('superadmin-adjust-credits-btn'),
  refreshRemote: document.getElementById('refresh-remote'),
  pageSize: document.getElementById('page-size'),
  removeClosedLots: document.getElementById('remove-closed-lots'),
  removeDeadMeat: document.getElementById('remove-dead-meat'),
  archiveUrls: document.getElementById('archive-urls'),
  bulkPriceCheck: document.getElementById('bulk-price-check'),
  exportCsv: document.getElementById('export-csv'),
  groupByAuction: document.getElementById('group-by-auction'),
  budgetWidget: document.getElementById('budget-widget'),
  openLotForm: document.getElementById('open-lot-form'),
  modal: document.getElementById('lot-modal'),
  modalBackdrop: document.getElementById('lot-modal-backdrop'),
  closeLotForm: document.getElementById('close-lot-modal'),
  cancelLotForm: document.getElementById('cancel-lot-modal'),
  lotFormTitle: document.getElementById('lot-form-title'),
  form: document.getElementById('lot-form'),
  rows: document.getElementById('rows'),
  sortClose: document.getElementById('sort-close'),
  pageInfo: document.getElementById('page-info'),
  prev: document.getElementById('prev'),
  next: document.getElementById('next'),
  q: document.getElementById('q'),
  filterFavorite: document.getElementById('filter-favorite'),
  filterClosingToday: document.getElementById('filter-closing-today'),
  filterClosingWeek: document.getElementById('filter-closing-week'),
  filterHighMargin: document.getElementById('filter-high-margin'),
  filterNeedsPrice: document.getElementById('filter-needs-price'),
  filterActiveBids: document.getElementById('filter-active-bids'),
  modeBannerLabel: document.getElementById('mode-indicator-label'),
  imagesModal: document.getElementById('images-modal'),
  imagesModalBackdrop: document.getElementById('images-modal-backdrop'),
  closeImagesModal: document.getElementById('close-images-modal'),
  imagesModalTitle: document.getElementById('images-modal-title'),
  imagesModalContent: document.getElementById('images-modal-content'),
  imageViewerModal: document.getElementById('image-viewer-modal'),
  imageViewerBackdrop: document.getElementById('image-viewer-backdrop'),
  closeImageViewer: document.getElementById('close-image-viewer'),
  imageViewerImg: document.getElementById('image-viewer-img') as HTMLImageElement,
  imageViewerContainer: document.getElementById('image-viewer-container'),
  imageViewerCounter: document.getElementById('image-viewer-counter'),
  imageViewerPrev: document.getElementById('image-viewer-prev'),
  imageViewerNext: document.getElementById('image-viewer-next'),
  lotDetailsModal: document.getElementById('lot-details-modal'),
  lotDetailsModalBackdrop: document.getElementById('lot-details-modal-backdrop'),
  closeLotDetailsModal: document.getElementById('close-lot-details-modal'),
  estimateModal: document.getElementById('estimate-modal'),
  estimateModalBackdrop: document.getElementById('estimate-modal-backdrop'),
  closeEstimateModal: document.getElementById('close-estimate-modal'),
  estimateLowValue: document.getElementById('estimate-low-value'),
  estimateHighValue: document.getElementById('estimate-high-value'),
  estimateForm: document.getElementById('estimate-form'),
  estimateCancel: document.getElementById('estimate-cancel'),
  estimateSave: document.getElementById('estimate-save'),
  closeTimeModal: document.getElementById('close-time-modal'),
  closeTimeModalBackdrop: document.getElementById('close-time-modal-backdrop'),
  closeCloseTimeModal: document.getElementById('close-close-time-modal'),
  closeTimeValue: document.getElementById('close-time-value'),
  closeTimeForm: document.getElementById('close-time-form'),
  closeTimeCancel: document.getElementById('close-time-cancel'),
  closeTimeSave: document.getElementById('close-time-save'),
  closeTimeClear: document.getElementById('close-time-clear'),
  closeTimeCustomIndicator: document.getElementById('close-time-custom-indicator'),
  creditAdjustmentModal: document.getElementById('credit-adjustment-modal'),
  creditAdjustmentModalBackdrop: document.getElementById('credit-adjustment-modal-backdrop'),
  closeCreditAdjustmentModal: document.getElementById('close-credit-adjustment-modal'),
  creditAdjustmentUserName: document.getElementById('credit-adjustment-user-name'),
  creditAdjustmentCurrentBalance: document.getElementById('credit-adjustment-current-balance'),
  creditAdjustmentForm: document.getElementById('credit-adjustment-form'),
  creditDelta: document.getElementById('credit-delta'),
  creditAdjustmentNote: document.getElementById('credit-adjustment-note'),
  creditNoteCharCount: document.getElementById('credit-note-char-count'),
  creditAdjustmentCancel: document.getElementById('credit-adjustment-cancel'),
  creditAdjustmentSave: document.getElementById('credit-adjustment-save'),
  subscriptionExtensionModal: document.getElementById('subscription-extension-modal'),
  subscriptionExtensionModalBackdrop: document.getElementById(
    'subscription-extension-modal-backdrop'
  ),
  closeSubscriptionExtensionModal: document.getElementById('close-subscription-extension-modal'),
  subscriptionExtensionUserName: document.getElementById('subscription-extension-user-name'),
  subscriptionExtensionCurrentExpiration: document.getElementById(
    'subscription-extension-current-expiration'
  ),
  subscriptionExtensionForm: document.getElementById('subscription-extension-form'),
  subscriptionMonths: document.getElementById('subscription-months'),
  subscriptionDays: document.getElementById('subscription-days'),
  subscriptionExtensionNote: document.getElementById('subscription-extension-note'),
  subscriptionNoteCharCount: document.getElementById('subscription-note-char-count'),
  subscriptionExtensionCancel: document.getElementById('subscription-extension-cancel'),
  subscriptionExtensionSave: document.getElementById('subscription-extension-save'),
  superadminExtendSubscriptionBtn: document.getElementById('superadmin-extend-subscription-btn'),
  hamburgerMenuBtn: document.getElementById('hamburger-menu-btn'),
  mobileMenu: document.getElementById('mobile-menu'),
  mobileMenuBackdrop: document.getElementById('mobile-menu-backdrop'),
  mobileMenuClose: document.getElementById('mobile-menu-close'),
  mobileViewAllLots: document.getElementById('mobile-view-all-lots'),
  mobileViewAllLotsLabel: document.getElementById('mobile-view-all-lots-label'),
  mobileOpenOptions: document.getElementById('mobile-open-options'),
  mobileLogout: document.getElementById('mobile-logout'),
  mobileMenuUserInfo: document.getElementById('mobile-menu-user-info'),
  mobileMenuUserName: document.getElementById('mobile-menu-user-name'),
  lotDetailsModalTitle: document.getElementById('lot-details-modal-title'),
  lotDetailsModalContent: document.getElementById('lot-details-modal-content'),
  lotCardsContainer: document.getElementById('lot-cards-container'),
  // Dashboard modal elements
  dashboardModal: document.getElementById('dashboard-modal'),
  dashboardModalBackdrop: document.getElementById('dashboard-modal-backdrop'),
  closeDashboardModal: document.getElementById('close-dashboard-modal'),
  dashboardModalContent: document.getElementById('dashboard-modal-content'),
  openDashboard: document.getElementById('open-dashboard'),
  f: {
    id: document.getElementById('lot-id') as HTMLInputElement,
    title: document.getElementById('lot-title') as HTMLInputElement,
    source: document.getElementById('lot-source') as HTMLSelectElement,
    nextRequiredBid: document.getElementById('lot-next-required-bid') as HTMLInputElement,
    close: document.getElementById('lot-close') as HTMLInputElement,
    url: document.getElementById('lot-url') as HTMLInputElement,
    description: document.getElementById('lot-description') as HTMLTextAreaElement,
  },
};
